import { inject } from 'inversify';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { IRepo, IRepoResponse } from '@core/repo';
import { appendToFormData, urlMaker } from '@core/utils';
import { bind } from '@infra/container';

export interface IToggleDeclarationWantedResponse {
  result: boolean;
  message?: string;
  is_wanted?: boolean;
  errors?: {
    declaration_id?: string[];
  };
}

export type IToggleDeclarationWantedRepoResponse = IRepoResponse<200, IToggleDeclarationWantedResponse> | IRepoResponse<400, string> | IRepoResponse<500, string>;

export type IToggleDeclarationWantedRepo = IRepo<[string, string | null], IToggleDeclarationWantedRepoResponse>;

export const ToggleDeclarationWantedRepoType = Symbol.for('ToggleDeclarationWantedRepo');

@bind(ToggleDeclarationWantedRepoType)
export class ToggleDeclarationWantedRepo implements IToggleDeclarationWantedRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(declarationId: string, descr: string | null = null) {
    try {
      const body = new FormData();
      appendToFormData({ descr }, body);

      const result = await this.httpClient.post({ url: urlMaker('/api/admin/declaration/wanted/toggle', { declaration_id: declarationId }), body });

      if (result.status === 200) {
        return {
          status: 200 as 200,
          response: result.data,
        };
      } else if (result.status === 400) {
        return {
          status: 400 as 400,
          response: result.data,
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Xəta baş verdi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi.',
      };
    }
  }
}
